(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ax-welcome"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ax-welcome')){
customElements.define('ax-welcome',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
this.dialog=this.querySelector('dialog');this.trigger=this.querySelector('[data-open]');
this.key='ax-welcome-dismissed-v1';this.previous=null;
this.trigger.addEventListener('click',()=>this.open());
this.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>this.dialog.close()));
this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.oldOverflow||'';try{localStorage.setItem(this.key,String(Date.now()));}catch(e){}this.previous?.focus();});
const success=this.querySelector('[data-success]'),errors=this.querySelector('[data-errors]');
if(success||errors){this.open();if(success){try{localStorage.setItem('ax-welcome-signed-v1','1');}catch(e){}success.focus();}return;}
let suppressed=false;try{suppressed=Boolean(localStorage.getItem('ax-welcome-signed-v1'))||Date.now()-Number(localStorage.getItem(this.key)||0)<604800000;}catch(e){}
if(this.dataset.known==='true')suppressed=true;
if(!suppressed&&!window.Shopify?.designMode)this.timer=setTimeout(()=>{if(document.visibilityState==='visible'&&!document.querySelector('dialog[open]'))this.open();},Number(this.dataset.delay)*1000);
}
open(){if(this.dialog.open)return;this.previous=document.activeElement;this.oldOverflow=document.documentElement.style.overflow;this.dialog.showModal();document.documentElement.style.overflow='hidden';}
disconnectedCallback(){clearTimeout(this.timer);if(this.dialog?.open)document.documentElement.style.overflow=this.oldOverflow||'';}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
